import React from 'react';
import * as FaIcons from 'react-icons/fa';

export const ONLINE_PAYMENT_DISABLED_MESSAGE =
    'Online ödeme hizmetimiz geçici olarak kullanılamamaktadır. Ödemenizi EFT/Havale ile gerçekleştirebilirsiniz. Detaylı bilgi için lütfen Helpdesk ile iletişime geçiniz.';

export const ONLINE_PAYMENT_ENABLED = false;

export const disabledPaymentButtonStyle = {
    backgroundColor: '#9e9e9e',
    borderColor: '#9e9e9e',
    color: '#ffffff',
    opacity: 1,
    cursor: 'not-allowed',
    pointerEvents: 'none'
};

function OnlinePaymentDisabledNotice({ style }) {
    if (ONLINE_PAYMENT_ENABLED) {
        return null;
    }

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 8,
                marginTop: 8,
                maxWidth: 520,
                width: '100%',
                color: '#c62828',
                fontSize: 13,
                lineHeight: 1.4,
                textAlign: 'left',
                ...style
            }}
        >
            <FaIcons.FaInfoCircle style={{ color: '#c62828', flexShrink: 0, marginTop: 2, fontSize: 16 }} />
            <span style={{ fontStyle: 'italic', fontWeight: 600 }}>{ONLINE_PAYMENT_DISABLED_MESSAGE}</span>
        </div>
    );
}

export default OnlinePaymentDisabledNotice;
